import SET_SHARED_ENV from './types';
export default {
  [SET_SHARED_ENV](state, payload) {
    var currentState = state;
    currentState.payload = payload;
  }

};